<template lang="pug">
  div
    .ev-label(v-if="toplabel && label")
      strong {{ label }}
    v-datetime-field(
      v-model="inputValue"
      :date-props="$attrs['date-props'] || defaultDateProps"
      :time-props="$attrs['time-props'] || defaultTimeProps"
      :time-picker-props="$attrs['time-picker-props'] || defaultTimePickerProps"
      :placeholder="toplabel && label || $attrs.placeholder"
      v-bind="$attrs"
      v-on="$listeners"
    )
      template(
        v-for="(_, name) in $scopedSlots"
        v-slot:[name]="data"
      )
        slot(:name="name" v-bind="data")
      template(
        v-for="(_, name) in $slots"
        :slot="name"
      )
        slot(:name="name")
</template>

<script>
import { VDatetimeField } from 'v-datetime-field';

export default {
  name: 'EvDatetimeField',
  components: { VDatetimeField },
  props: {
    value: { type: [String], default: null },
    toplabel: { type: Boolean, default: false },
    label: { type: String, default: null },
    labelDate: { type: String, default: 'Дата' },
    labelTime: { type: String, default: 'Время' },
  },
  data() {
    return {
      inputValue: null,
      defaultDateProps: {
        rounded: true,
        filled: true,
        label: this.labelDate,
      },
      defaultTimeProps: {
        rounded: true,
        filled: true,
        label: this.labelTime,
      },
      defaultTimePickerProps: {
        color: 'secondary',
      },
    };
  },
  watch: {
    value: {
      handler(val) {
        this.inputValue = val;
      },
      immediate: true,
    },
    inputValue: {
      handler(val) {
        if (val) this.$emit('input', val);
      },
      immediate: true,
    },
  },
};
</script>
